import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colours } from 'themes/default';

const StyledContents = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  width: 100%;
  align-items: stretch;
  margin-bottom: 5px;
`;

const StyledTab = styled(Link)`
  text-decoration: none;
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border-radius: 7px 7px 0px 0px;
  border: 1px solid transparent;
  border-color: ${(props) => (props.selected ? colours.Greyscale.Black : colours.Greyscale.CharcoalGrey)};
  border-bottom: none;
  filter: ${(props) => (props.hovered ? 'brightness(50%)' : 'brightness(100%)')};
  color: ${(props) => (props.selected ? colours.Greyscale.CharcoalGrey : colours.Greyscale.White)};
  font-weight: ${(props) => (props.selected ? 600 : 400)};
  background-color: ${(props) => (props.selected ? colours.Greyscale.White : colours.Core.CoreNavy)};
  min-height: 2em;

  &:hover {
    opacity: ${(props) => (props.selected ? '' : '0.5')};
  }
`;

export { StyledContents, StyledTab };
